import type { SVGProps } from "react";

export default function DocumentInboxIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.75003 11.8125H29.25L36 18.5625H0L6.75003 11.8125Z"
        fill="#F5A801"
      />
      <path
        d="M7.87487 14.0625H28.1248L33.7498 19.6875C33.7498 19.6875 33.2886 25.3125 32.4752 25.3125H3.31195C2.6325 25.3125 2.25 19.6875 2.25 19.6875L7.87487 14.0625Z"
        fill="#F5A801"
      />
      <path
        d="M6.75004 1.6875H29.25C29.8722 1.6875 30.375 2.19153 30.375 2.81254V21.9375C30.375 22.5585 29.8722 23.0625 29.25 23.0625H6.75004C6.12786 23.0625 5.625 22.5585 5.625 21.9375V2.81243C5.625 2.19153 6.12786 1.6875 6.75004 1.6875Z"
        fill="#F4F4F4"
      />
      <path
        d="M10.125 7.31259H25.875C26.4971 7.31259 27 6.80856 27 6.18754C27 5.56653 26.4971 5.0625 25.875 5.0625H10.125C9.50286 5.0625 9 5.56653 9 6.18754C9 6.80856 9.50298 7.31259 10.125 7.31259ZM25.8751 9.56256H10.125C9.50286 9.56256 9 10.0666 9 10.6876C9 11.3086 9.50286 11.8126 10.125 11.8126H25.875C26.4971 11.8126 27 11.3098 27 10.6876C27 10.0654 26.4971 9.56256 25.8751 9.56256ZM25.8751 14.0625H10.125C9.50286 14.0625 9 14.5665 9 15.1875C9 15.8086 9.50286 16.3126 10.125 16.3126H25.875C26.4971 16.3126 27 15.8086 27 15.1875C27 14.5665 26.4971 14.0625 25.8751 14.0625Z"
        fill="#C4C4C4"
      />
      <path
        d="M24.7499 18.5625V20.8125C24.7499 22.0555 23.742 23.0624 22.4999 23.0624H13.4999C12.2579 23.0624 11.25 22.0545 11.25 20.8125V18.5625H0V32.0624C0 33.3045 1.00794 34.3124 2.24997 34.3124H33.7499C34.9919 34.3124 35.9999 33.3045 35.9999 32.0624V18.5625H24.7499Z"
        fill="#F5A801"
      />
    </svg>
  );
}
